/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type PinterestPinIcon_user = {|
  +serviceId: ?string;
  +socialNetworks: ?$ReadOnlyArray<?{|
    +status?: ?string;
  |}>;
|};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PinterestPinIcon_user",
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "args": null,
      "name": "serviceId",
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "socialNetworkNames",
          "value": [
            "PINTEREST"
          ],
          "type": "[SocialNetworkNames]"
        }
      ],
      "concreteType": null,
      "name": "socialNetworks",
      "plural": true,
      "selections": [
        {
          "kind": "InlineFragment",
          "type": "PinterestSocialNetwork",
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "PinterestConnectBoardModal_userSocialNetwork",
              "args": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "status",
              "storageKey": null
            }
          ]
        }
      ],
      "storageKey": "socialNetworks{\"socialNetworkNames\":[\"PINTEREST\"]}"
    }
  ],
  "type": "User"
};

module.exports = fragment;



// WEBPACK FOOTER //
// ./assets/js/global/components/Pinterest/__generated__/PinterestPinIcon_user.graphql.js